// src/context/LoaderContext.js
import React, { createContext, useContext, useState } from "react";
import GlobalLoader from "../../Components/GlobalLoaderPage";

const LoaderContext = createContext();

export function useLoader() {
  const context = useContext(LoaderContext);
  if (!context) {
    throw new Error("useLoader must be used within LoaderProvider");
  }
  return context;
}

export function LoaderProvider({ children }) {
  const [open, setOpen] = useState(false);

  const showLoader = () => setOpen(true);
  const hideLoader = () => setOpen(false);

  return (
    <LoaderContext.Provider value={{ showLoader, hideLoader }}>
      {children}
      <GlobalLoader open={open} />
    </LoaderContext.Provider>
  );
}
